<template>
    <div  class="container">
        <div class="row">
            <div class="col-12">
                <h5 class="mt-3 mb-3" v-if="name">{{ $t("home.welcome") }} {{ name }},</h5>
                <h5 class="mt-3 mb-3" v-else>{{ $t("home.welcome") }},</h5>
                <p class="mt-2">
                    {{ $t("home.title") }}
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <p>{{ $t("home.topics") }}</p>
                <CategoryList/>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <p>{{ $t("home.email") }}</p>
                <Category :is-icon="true" icon-src="envelope" :name="$t('home.emailButton')" @click="openMail"></Category>
            </div>
        </div>
    </div>
</template>

<script>
    import CategoryList from "./CategoryList.vue";
    import log from "../../../utils/log";
    import Category from "./Category";

    export default {
        components: {Category, CategoryList},
        beforeMount() {
            this.$communicator.setPageTitle(this.$i18n.t("topBar.title"));
            this.$communicator.getMeinJenaUser().then(user => {
                this.$store.dispatch("user", user);
            }).catch(e => this.$store.commit("error", e.message));
        },
        computed: {
            name() {
                return this.$store.getters.fullName;
            },
        },
        methods: {
            openMail() {
                this.$communicator.openMail();
            }
        }
    }
</script>
<style lang="scss" scoped>
    span {
        display: block;
        text-align: left;
        svg {
            margin-right: 4px;
            margin-top: -4px;
        }
    }
</style>
